module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block block-themed"
  }, [_c('div', {
    staticClass: "block-header bg-primary-dark"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [(_vm.sumAlertActualChannel > 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    staticClass: "h3 text-white"
  }, [_vm._v(_vm._s(_vm.sumAlertActualChannel))]), _vm._v(" "), _c('i', {
    staticClass: "h1 fa fa-bell fa-2x push-15-r "
  })])]) : _vm._e(), _vm._v(" "), _c('li', [(_vm.channelSharingEnableFlag) ? _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.shareEntity()
      }
    }
  }, [_c('i', {
    staticClass: "h1 fa fa-share-alt fa-2x push-15-r "
  })]) : _vm._e()]), _vm._v(" "), (_vm.flagDisplayChannel === 0) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-down fa-2x"
  })])]) : _vm._e(), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-up fa-2x"
  })])]) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "h3 block-title",
    on: {
      "click": function($event) {
        return _vm.toggleDisplayChannel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-television fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), (_vm.flagDisplayChannel) ? _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelRefrenceName[_vm.actualLanguage]) + " (ID: " + _vm._s(_vm.channelIDLast4) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName),
      expression: "tempoBundle.channels[channelIndex].ReferenceName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex], "ReferenceName", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.channelConfigViewFlag) ? _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_c('i', {
    staticClass: "fa fa-gear push"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceConfig[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: " col-xs-12 col-md-8 push"
  }, [_c('label', {
    staticClass: "h4 col-xs-12"
  }, [_vm._v(_vm._s(_vm.textLabelName[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 push"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName),
      expression: "tempoBundle.channels[channelIndex].ChannelData.channelInfo.channelName"
    }],
    staticClass: "h4 form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.channelName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo, "channelName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "h4 col-xs-12"
  }, [_vm._v("Description")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description),
      expression: "tempoBundle.channels[channelIndex].ChannelData.channelInfo.description"
    }],
    staticClass: "h4 form-control",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [_c('div', {
    staticClass: "form-group appliance-list-wrap"
  }, [_c('p', [_c('img', {
    attrs: {
      "width": "100px",
      "src": _vm._f("s3Image")(("appliances/" + (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelInfo.iconFile)))
    },
    on: {
      "click": function($event) {
        _vm.showApplianceList = !_vm.showApplianceList
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-big btn-primary btn-rounded",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        _vm.showApplianceList = !_vm.showApplianceList
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })]), _vm._v(" "), (_vm.showApplianceList) ? _c('appliance-list', {
    staticClass: "appliance-list",
    on: {
      "onSelect": _vm.onApplianceSelect
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.channelConfigEditFlag) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.displayDevicePortConfig) ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedModule[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId),
      expression: "tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.deviceId"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "1"
    },
    on: {
      "click": function($event) {
        return _vm.validateIfChannelDeviceInDeviceList()
      },
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts, "deviceId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "Aucun/None"
    }
  }, [_vm._v("Aucun/None")]), _vm._v(" "), _vm._l((_vm.tempoBundle.devices), function(device) {
    return _c('option', {
      domProps: {
        "value": device.DeviceData.deviceId
      }
    }, [_vm._v(_vm._s(device.ReferenceName))])
  })], 2)])])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 align-center push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.messageLinkedModuleNotInSystem[_vm.actualLanguage]))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-xs",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        _vm.displayDevicePortConfig = true
      }
    }
  }, [_vm._v(_vm._s(_vm.messageModifyForModuleInSystem[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.thisChannelDeviceIndex >= 0) ? _c('div', [(_vm.displayDevicePortConfig & _vm.thisChannelDeviceIndex >= 0 & _vm.tempoBundle.devices[_vm.thisChannelDeviceIndex].DeviceData.frontendComponents.componentChannelConfig == 'EVA_V1P00') ? _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('label', {
    staticClass: "col-xs-12",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.selectLabelLinkedPort[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.ports),
      expression: "tempoBundle.channels[channelIndex].ChannelData.linkedDevicePorts.ports"
    }],
    staticClass: "form-control",
    attrs: {
      "size": "4",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts, "ports", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Port 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Port 2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Port 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Port 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Port 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Port 6")])])]), _vm._v(" "), _c('label', {
    staticClass: "col-xs-12 push",
    attrs: {
      "for": "example-multiple-select"
    }
  }, [_vm._v(_vm._s(_vm.textSelectMultiplePort[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12"
  }, [_c('div', {
    staticClass: "block block-bordered block-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 align-center push"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_vm._v(_vm._s(_vm.titleLivePanel[_vm.actualLanguage]))])]), _vm._v(" "), _c('span', [(_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "col-xs-12 col-sm-9"
  }, [_c('h5', {
    staticClass: "h4 font-w200 text-center"
  }, [_vm._v(_vm._s(_vm.addThisChannelToLivePanel[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('div', {
    staticClass: "col-xs-12 col-sm-3 push"
  }, [_c('label', {
    staticClass: "css-input switch switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled),
      expression: "tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.enabled"
    }],
    attrs: {
      "type": "checkbox",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled) ? _vm._i(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled, null) > -1 : (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "enabled", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "enabled", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "enabled", $$c)
        }
      }
    }
  }), _c('span')])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h6', {
    staticClass: "h4 font-w200 text-center push"
  }, [_vm._v(_vm._s(_vm.realTimeMeasurementPanelNotAvailable[_vm.actualLanguage]))])])]), _vm._v(" "), (_vm.actualBundle.bundleRights.realTimeMeasurementPanel) ? _c('span', [(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 col-xs-12 col-sm-9"
  }, [_vm._v(_vm._s(_vm.warningLevelLivePanel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel),
      expression: "tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerWarningLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "powerWarningLevel", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.enabled) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "h4 col-xs-12 col-sm-9"
  }, [_vm._v(_vm._s(_vm.limitLevelLivePanel[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-3 "
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel),
      expression: "tempoBundle.channels[channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel"
    }],
    staticClass: "form-control align-center",
    attrs: {
      "type": "test",
      "id": "lock1-password",
      "name": "lock1-password",
      "placeholder": "Entrez votre information"
    },
    domProps: {
      "value": (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration.powerLimitLevel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.liveMeasurementConfiguration, "powerLimitLevel", $event.target.value)
      }
    }
  })])]) : _vm._e()]) : _vm._e()])])])]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.actualBundle.channelsAttributes.length > 0 & false) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_c('i', {
    staticClass: "fa fa-tags"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceTags[_vm.actualLanguage]))]), _vm._v(" "), _vm._l((_vm.actualBundle.channelsAttributes), function(categoryList, index) {
    return _c('div', [_c('div', {
      staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-4"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-xs-12",
      attrs: {
        "for": "example-select"
      }
    }, [_vm._v(_vm._s(categoryList.title))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 col-sm-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.tempoBundle.channels[_vm.channelIndex].Attributes[index]),
        expression: "tempoBundle.channels[channelIndex].Attributes[index]"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "example-select",
        "name": "example-select",
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.tempoBundle.channels[_vm.channelIndex].Attributes, index, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((categoryList.data), function(element, index2) {
      return _c('option', {
        domProps: {
          "value": element
        }
      }, [_vm._v(_vm._s(element))])
    }), 0)])])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 items-push"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [(_vm.channelConfigDeleteFlag) ? _c('button', {
    staticClass: "h4 btn btn-danger",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "type": "button",
      "name": "buttonDeletePlanItem2"
    },
    on: {
      "click": function($event) {
        return _vm.confirmRemoveChannel()
      }
    }
  }, [(_vm.channelIsDeleting) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-trash fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelDeleteDevice[_vm.actualLanguage]))])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6"
  }, [_c('p', [(_vm.channelConfigEditFlag) ? _c('button', {
    staticClass: "h4 btn btn-success align-right",
    attrs: {
      "type": "button",
      "name": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveChannelModifications()
      }
    }
  }, [(_vm.channelIsSaving) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-floppy-o fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.buttonLabelSaveDevice[_vm.actualLanguage]))])], 1) : _vm._e()])])]), _vm._v(" "), (_vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId != 'TBD' & _vm.channelConfigEditFlag & _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.linkedDevicePorts.deviceId != 'Aucun/None') ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "col-xs-12 push"
  }, [_c('h4', {
    staticClass: "h2"
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), _vm._v(" " + _vm._s(_vm.sectionLabelDeviceAlert[_vm.actualLanguage]))])]), _vm._v(" "), _vm._l((_vm.actualBundle.alerts), function(alert, index) {
    return _c('div', {
      staticClass: "col-xs-12"
    }, [(alert.AlertData.linked_channel[0] === _vm.tempoBundle.channels[_vm.channelIndex].ChannelData.channelId) ? _c('div', {
      staticClass: "block-content"
    }, [_c('config-alert', {
      attrs: {
        "alertIndex": index
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.alertShowAddButton) ? _c('div', {
    staticClass: "form-group"
  }, [(_vm.flagDisplayAlertConfig) ? _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [(_vm.channelConfigEditFlag) ? _c('button', {
    staticClass: "h4 btn btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        return _vm.openAlertAddMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _c('i', {
    staticClass: "fa fa-bell fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonAddAlert[_vm.actualLanguage]))]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('h5', {
    staticClass: "h4"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" " + _vm._s(_vm.labelUserMustSubscribeToConfigAlert[_vm.actualLanguage]))])])]) : _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "block block-bordered"
  }, [_c('div', {
    staticClass: "block-header bg-gray-lighter"
  }, [_c('ul', {
    staticClass: "block-options"
  }, [_c('li', [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.alertShowAddButton = true
      }
    }
  }, [_c('i', {
    staticClass: "si si-plus"
  })])])]), _vm._v(" "), _c('h3', {
    staticClass: "block-title"
  }, [_vm._v(_vm._s(_vm.labelFieldButtonAddAlert[_vm.actualLanguage]) + " " + _vm._s(_vm.tempoBundle.channels[_vm.channelIndex].ReferenceName))])]), _vm._v(" "), _c('div', {
    staticClass: "block-content"
  }, [_c('div', {
    staticClass: "col-xs-6 col-md-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labelAlertSelect[_vm.actualLanguage]))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.alertToAddIndex),
      expression: "alertToAddIndex"
    }],
    staticClass: "js-select2",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.alertToAddIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.alertsDefinitions), function(alert, index) {
    return _c('option', {
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(alert.alertTitle[_vm.actualLanguage]))])
  }), 0)]), _vm._v(" "), _c('p', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "width": "600px",
      "src": _vm._f("s3Image")(("alerts/" + (_vm.alertsDefinitions[_vm.alertToAddIndex].icon[_vm.actualLanguage])))
    }
  })]), _vm._v(" "), (_vm.alertsDefinitions[_vm.alertToAddIndex].alertDescription) ? _c('div', {
    staticClass: "col-xs-12 col-md-12 push"
  }, [_c('h6', [_vm._v(_vm._s(_vm.alertsDefinitions[_vm.alertToAddIndex].alertDescription[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAlertParameter[_vm.actualLanguage]))]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v(_vm._s(_vm.tableTitleAlertParameterValue[_vm.actualLanguage]))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.alertsDefinitions[_vm.alertToAddIndex].parameters), function(parameter, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(parameter.parameterTitle[_vm.actualLanguage]))]), _vm._v(" "), (parameter.dataType === 'Numeric') ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control text-center",
      attrs: {
        "type": "test",
        "id": "lock1-password",
        "name": "lock1-password",
        "placeholder": "Entrez votre information"
      },
      domProps: {
        "value": (parameter.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parameter, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'Boolean') ? _c('td', [_c('label', {
      staticClass: "css-input switch switch-success"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      attrs: {
        "type": "checkbox",
        "checked": ""
      },
      domProps: {
        "checked": Array.isArray(parameter.value) ? _vm._i(parameter.value, null) > -1 : (parameter.value)
      },
      on: {
        "change": function($event) {
          var $$a = parameter.value,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(parameter, "value", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(parameter, "value", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(parameter, "value", $$c)
          }
        }
      }
    }), _c('span')])]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateMonth') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.monthOptions), function(month) {
      return _c('option', {
        domProps: {
          "value": month.value
        }
      }, [_vm._v(_vm._s(month.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateDay') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.dayOptions), function(day) {
      return _c('option', {
        domProps: {
          "value": day.value
        }
      }, [_vm._v(_vm._s(day.text))])
    }), 0)]) : _vm._e(), _vm._v(" "), (parameter.dataType === 'DateHour') ? _c('td', [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parameter.value),
        expression: "parameter.value"
      }],
      staticClass: "form-control",
      attrs: {
        "size": "1"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(parameter, "value", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.hourOptions), function(hour) {
      return _c('option', {
        domProps: {
          "value": hour.value
        }
      }, [_vm._v(_vm._s(hour.text))])
    }), 0)]) : _vm._e()])
  }), 0)])])]), _vm._v(" "), _c('button', {
    staticClass: "h4 btn btn-success",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": _vm.addAlertLine
    }
  }, [(_vm.alertIsCreating) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('span', [_c('i', {
    staticClass: "fa fa-plus fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonConfirmAddAlert[_vm.actualLanguage]))])], 1), _vm._v(" "), _c('button', {
    staticClass: "h4 btn btn-danger",
    attrs: {
      "type": "button",
      "name": "buttonAddPlanItem"
    },
    on: {
      "click": function($event) {
        _vm.alertShowAddButton = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close fa-1x push-5-r "
  }), _vm._v(_vm._s(_vm.labelFieldButtonCancelAddAlert[_vm.actualLanguage]))])])])])])], 2) : _vm._e()])])]) : _vm._e()])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56833c36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/configuration/ConfigChannel.vue
// module id = 1548
// module chunks = 4